import { gql } from '@apollo/client'
import { workOrderDocumentFragment } from './graphql'
import { useActionMutation, type UseActionResult, type UseMutationProps } from '@ztechapps/common.hook'
import type { UnlinkWorkOrderTaskArgs, WorkOrder } from '@ztechapps/common.contract'

export const unlinkWorkOrderTaskQuery = gql`
  mutation unlinkWorkOrderTask($input: UnlinkWorkOrderTaskArgs!) {
    unlinkWorkOrderTask(input: $input) {
      ...workOrderDocumentFragment
    }
  }
  ${workOrderDocumentFragment}
`

export const useUnlinkWorkOrerTask = (
  { query, ...props } = {} as UseMutationProps
): UseActionResult<WorkOrder, UnlinkWorkOrderTaskArgs> => {
  query = query ?? unlinkWorkOrderTaskQuery

  return useActionMutation({
    query,
    ...props,
  })
}
